import React from "react";
import { Grid, Container } from "@mui/material";
import DeliveryHead from "../DeliveryHead";
import Clothesbox from "../../../../assets/images/Clothesbox.png";
import calendar from "../../../../assets/images/calendar.png";
import recordcircle from "../../../../assets/images/record-circle.png";
import location from "../../../../assets/images/location.png";
import comment from "../../../../assets/images/comment.png";
import camera from "../../../../assets/images/camera.png";
import orderimg from "../../../../assets/images/orderimg.png";
import Successmark from "../../../../assets/images/Successmark.png";
import MainButton from "../../../shared/Button";
import {
  QuoteApprovedMain,
  PreviewOrderHeader,
  QuoteItem,
  SuccessmarkImg,
} from "../styles/QuoteApprovedStyle";

const QuoteApproved = () => {
  const isMobile = window.innerWidth <= 767;
  return (
    <>
      {!isMobile ? (
        <DeliveryHead
          Value={50}
          BackLink="/price-quotation"
          CenterText="Quote Approved"
          StepText="2 of 4"
          showBox={false}
          showLink={false}
        />
      ) : null}
      <QuoteApprovedMain>
        <Container maxWidth="lg">
          <PreviewOrderHeader>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={12} md={10} lg={5}>
                <SuccessmarkImg src={Successmark} alt="Successmark" />
                <h6>Quote Approved</h6>
                <p>
                  You’ve successfully approved the quote.
                  <br /> Check the details below.
                </p>
                <QuoteItem>
                  <div className="Quote_ItemMain">
                    <img src={Clothesbox} alt="Clothesbox" />
                    <span>Clothes</span>
                  </div>
                  <div className="date_ItemMain">
                    <img src={calendar} alt="Clothesbox" />
                    <span>23 January, 02:30 PM</span>
                  </div>
                  <div className="pickup_ItemMain">
                    <img src={recordcircle} alt="Clothesbox" />
                    <span>1213 Washington Blvd, Belpre, OH </span>
                  </div>
                  <div className="drop_ItemMain">
                    <img src={location} alt="Clothesbox" />
                    <span>121 Pike St, Marietta, OH </span>
                  </div>
                  <div className="many_orders">
                    <img src={comment} alt="Clothesbox" />
                    <span>2 Boxes of clothes</span>
                  </div>
                  <div className="orders_image">
                    <img src={camera} alt="comment" />
                    <img src={orderimg} alt="orderImg" className="orderImg" />
                  </div>
                  <MainButton type="button" label="Back to Home" />
                </QuoteItem>
              </Grid>
            </Grid>
          </PreviewOrderHeader>
        </Container>
      </QuoteApprovedMain>
    </>
  );
};

export default QuoteApproved;
